<div class="widget-container" #dataEditGridDiv>
    <!-- Headings -->
    <main >
        <article #fs fullscreen-able [class.is-active]="isActive" [class.isFulScreen]="isActive" style="background-color: #fff;">
            <div class="mb-1">
                <icon-chart 
                    [headerConfig]="item.config?.widget_header_config"
                    [rowDataLength]="this.rowData" 
                    [data]="this.rowData" 
                    [pageKey]="pageKey" 
                    [heading]="this.item.config['report_heading']"
                    [chartName]="'GridList'" 
                    [expand]="fs" 
                    [fullscreen]="isFullscreen"
                    [item]="item"
                    [paginationPageSize]="paginationPageSize"
                    [config]="BasicGridDiv" 
                    [clientSideSearchFilterText]="serverSideSearchFilterText"
                    [selectedSearchByKey]="selectedSearchByKey"
                    [serverSideSearchFilterText]="serverSideSearchFilterText"
                    (typeToSearch)="onQuickFilterChanged($event)"
                    (serverSideSearchEmits)="serverSideSearchEmits($event)"
                    (screenChanges)="screenChanges($event)"
                    (exportXls)="exportXls($event)"
                    (onPageSizeChange)="onPageSizeChanged($event)"
                    (preferenceEmitter)="preferenceEmitter()"
                ></icon-chart>

            </div>
            <div *ngIf="loader" style="width: 100%; height: 200px;">
                <loading></loading>
            </div>

            <div style="height: 200px; width: auto; " *ngIf="!loader && rowData.length==0">
                <span class="bg-text"> {{ error_name ? error_name : 'There is no data for this time period' }} </span>
            </div>

            <div #BasicGridDiv>
            <ag-grid-angular
                style="width: 100%;padding: 0 0 10px;"
                [style.height]="!loader?'100%':'200px'"
                class="ag-theme-alpine editDataGrid"
                [style.display]="(rowData.length==0 || error_name) ? 'none' : 'block'"
                [class.fullScreenEdits]="isFullscreen"
                [columnDefs]="columnConfig"
                [defaultColDef]="defaultColDef"
                [rowData]="rowData"
                [class]="themeClass"
                [suppressDragLeaveHidesColumns]="true"
                [suppressContextMenu]="false"
                [rowHeight]="50"
                [pagination]="paginationFlag"
                [suppressRowTransform]="true"
                [isExternalFilterPresent]="isExternalFilterPresent"
                [doesExternalFilterPass]="doesExternalFilterPass"
                [gridOptions]="gridOptions"
                [paginationPageSize]="paginationPageSize"
                (cellClicked)="onCellClicked($event)"
                 [excelStyles]="excelStyles"
                (paginationChanged)="addCustomTextToPagination()"
                [paginationPageSizeSelector]="paginationPageSizeSelector"
                (gridReady)="onGridReady($event)"
            >
            </ag-grid-angular>
            </div>
        </article>
    </main>
</div>